import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

import { AuthProvider } from './AuthContext';
import { PWAProvider } from './pwa/PWAContext';

import { initGA } from './analytics.js';

initGA();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <PWAProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </PWAProvider>
  </React.StrictMode>
);

reportWebVitals();